import $ from 'jquery';
import 'jquery.scrollto';

// Scroll
export const scrollToHash = (hash) => {
    let $top = $('.topmenu').outerHeight() * -1 - 20;

    const $mm = $('.mobile-menu');
    if ($mm.is(':visible') == true) {
        $top = $mm.outerHeight() * -1;
    }

    $.scrollTo(hash, 2000, {offset: {top: $top, left: 0}});
};



// WEBPACK FOOTER //
// ./js/common/scroll.js